import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import {
  Contact,
  ContactListOption,
  ContactRetentionEntry,
  ContactRetentionOverviewSort,
  ContactsSort,
  ICreateContactParams,
  IGetContactResponse,
  IGetContactsListResponse,
  IGetJobFunctionsListResponse,
  JobFunction,
} from './interfaces';
import {
  IPaginatedResourceEndpointResponse,
  IUpsertResourceResponse,
} from '../interfaces';
import { getPaginatedEndpointParams } from '../helpers';
import { FilterFields } from '../../components/ManagedDataTable/interfaces';

export const getContacts = async (
  page: number,
  pageSize: number,
  sort?: ContactsSort,
  search?: string,
  filters?: FilterFields
): Promise<IPaginatedResourceEndpointResponse<Contact>> => {
  const response: AxiosResponse<IPaginatedResourceEndpointResponse<Contact>> =
    await apiClient.get('/contacts', {
      params: getPaginatedEndpointParams({
        page,
        perPage: pageSize,
        sort,
        search,
        filters,
      }),
    });

  return response.data;
};

export const getContact = async (id: number): Promise<Contact> => {
  const response: AxiosResponse<IGetContactResponse> = await apiClient.get(
    `/contacts/${id}`
  );

  return response.data.data;
};

export const createContact = async (
  contactData: ICreateContactParams
): Promise<number> => {
  const response: AxiosResponse<IUpsertResourceResponse> = await apiClient.post(
    '/contacts/',
    contactData
  );

  return response.data.data.id;
};

export const updateContact = async (
  contactId: number,
  contactData: ICreateContactParams
): Promise<number> => {
  const response: AxiosResponse<IUpsertResourceResponse> = await apiClient.put(
    `/contacts/${contactId}`,
    contactData
  );

  return response.data.data.id;
};

export const deleteContact = async (id: number): Promise<void> => {
  await apiClient.delete(`/contacts/${id}`);
};

export const getJobFunctionsList = async (): Promise<JobFunction[]> => {
  const response: AxiosResponse<IGetJobFunctionsListResponse> =
    await apiClient.get('/contacts/job-functions/list');

  return response.data.data;
};

export const getContactsList = async (): Promise<ContactListOption[]> => {
  const response: AxiosResponse<IGetContactsListResponse> = await apiClient.get(
    '/contacts/list'
  );

  return response.data.data;
};

export const getClientContactsList = async (
  clientId: number
): Promise<ContactListOption[]> => {
  const response: AxiosResponse<IGetContactsListResponse> = await apiClient.get(
    `/clients/${clientId}/contacts/list`
  );

  return response.data.data;
};

export const getContactRetentionOverview = async (
  page: number,
  pageSize: number,
  sort?: ContactRetentionOverviewSort,
  search?: string,
  filters?: FilterFields
): Promise<IPaginatedResourceEndpointResponse<ContactRetentionEntry>> => {
  const response: AxiosResponse<
    IPaginatedResourceEndpointResponse<ContactRetentionEntry>
  > = await apiClient.get('/contacts/retention-overview', {
    params: getPaginatedEndpointParams({
      page,
      perPage: pageSize,
      sort,
      search,
      filters,
    }),
  });

  return response.data;
};
